import React from "react";
import { X } from "@phosphor-icons/react";

export default function BulkActionBar({ count, onClear, children }) {
  if (count === 0) return null;
  return (
    <div
      data-testid="bulk-action-bar"
      className="sticky top-2 z-20 flex items-center gap-3 px-4 py-2.5 bg-[#1A3A21] text-white rounded-lg shadow-lg flex-wrap"
    >
      <button
        onClick={onClear}
        data-testid="bulk-clear"
        className="text-white/80 hover:text-white p-1 rounded hover:bg-white/10"
        title="Clear selection"
      >
        <X size={16} weight="bold" />
      </button>
      <span className="text-sm font-semibold">
        {count} selected
      </span>
      <div className="ml-auto flex items-center gap-2 flex-wrap">{children}</div>
    </div>
  );
}
